var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { formatDate as format } from '@/support/String';
import { Timeslot } from '@/models/Timeslot';
let AddTimeslotDialog = class AddTimeslotDialog extends Vue {
    constructor() {
        super(...arguments);
        this.newTimeslot = null;
        this.days = [
            { text: 'Ma.', value: 1 },
            { text: 'Di.', value: 2 },
            { text: 'Wo.', value: 3 },
            { text: 'Do.', value: 4 },
            { text: 'Vr.', value: 5 },
        ];
        this.selectedDay = [];
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    createOrUpdate() {
        if (!this.newTimeslot || this.selectedDay.length === 0) {
            return;
        }
        if (this.newTimeslot.id) {
            this.update();
        }
        else {
            this.create();
        }
    }
    create() {
        if (!this.newTimeslot) {
            return;
        }
        let callCount = 0;
        const newTimeslots = [];
        this.selectedDay.forEach((day) => {
            const slot = this.newTimeslot.clone();
            slot.day = day;
            slot
                .include('activities')
                .create()
                .then((event) => {
                newTimeslots.push(event);
                callCount += 1;
                if (callCount >= this.selectedDay.length) {
                    this.$emit('eventCreated', newTimeslots);
                    this.$emit('input', false);
                    this.clear();
                }
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    clear() {
        this.newTimeslot = new Timeslot();
    }
    update() {
        if (!this.newTimeslot) {
            return;
        }
        this.newTimeslot
            .update()
            .then((timeslot) => {
            this.$emit('eventUpdated', timeslot);
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    remove() {
        if (!this.newTimeslot) {
            return;
        }
        const eventId = this.newTimeslot.id;
        this.newTimeslot
            .delete()
            .then(() => {
            this.$emit('eventRemoved', eventId);
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    parseEvent(event) {
        const parsed = {
            id: event.id,
            title: event.title,
            start: event.starts_at,
            ends: event.ends_at,
            editable: true,
            className: `${event.type}__events`,
        };
        return parsed;
    }
    timeslotChanged(timeslot) {
        if (timeslot) {
            this.newTimeslot = timeslot.clone();
            this.selectedDay = [parseInt(this.newTimeslot.day)];
            this.newTimeslot.template = this.templateId;
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof Timeslot !== "undefined" && Timeslot) === "function" ? _a : Object)
], AddTimeslotDialog.prototype, "timeslot", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], AddTimeslotDialog.prototype, "templateId", void 0);
__decorate([
    Watch('timeslot'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Timeslot !== "undefined" && Timeslot) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], AddTimeslotDialog.prototype, "timeslotChanged", null);
AddTimeslotDialog = __decorate([
    Component({
        components: {
            SelectFilter,
        },
        filters: {
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
        },
    })
], AddTimeslotDialog);
export default AddTimeslotDialog;
